module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collapse', {
    attrs: {
      "selected": !!_vm.openedFields[_vm.item.name]
    },
    on: {
      "toggle": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "collapsible-header",
    attrs: {
      "slot": "collapsible-header"
    },
    slot: "collapsible-header"
  }, [(_vm.item.type === 'destination-account') ? _c('span', [_vm._v("* ")]) : _vm._e(), _c('i', {
    class: _vm.icon
  }), _vm._v(" "), (_vm.descriptionRichEdit) ? _c('span', {
    staticClass: "header-title text-ellipsis"
  }, [_vm._v(_vm._s(_vm.item.label))]) : _c('span', {
    staticClass: "header-title text-ellipsis"
  }, [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('div', {
    staticClass: "header-buttons"
  }, [(!_vm.isFormLocked) ? _c('i', {
    staticClass: "icon-settings"
  }) : _vm._e(), _vm._v(" "), (!_vm.isFormLocked) ? _c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.duplicate.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isFormLocked) ? _c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.remove.apply(null, arguments)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isFormLocked) ? _c('div', {
    staticClass: "collapsible-body",
    attrs: {
      "slot": "collapsible-body"
    },
    slot: "collapsible-body"
  }, [_vm._t("header"), _vm._v(" "), (_vm.showRequired) ? _c('editor-checkbox', {
    attrs: {
      "label": "Required",
      "id": _vm.item.name + '_required'
    },
    model: {
      value: (_vm.item.required),
      callback: function($$v) {
        _vm.$set(_vm.item, "required", $$v)
      },
      expression: "item.required"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHideInForm) ? _c('editor-checkbox', {
    attrs: {
      "label": "Hide in form",
      "id": _vm.item.name + '_hide'
    },
    model: {
      value: (_vm.item.hide),
      callback: function($$v) {
        _vm.$set(_vm.item, "hide", $$v)
      },
      expression: "item.hide"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHideInReports) ? _c('editor-checkbox', {
    attrs: {
      "label": "Hide in reports",
      "id": _vm.item.name + '_hide_in_reports'
    },
    model: {
      value: (_vm.item.hideInReports),
      callback: function($$v) {
        _vm.$set(_vm.item, "hideInReports", $$v)
      },
      expression: "item.hideInReports"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHideInPreview) ? _c('editor-checkbox', {
    attrs: {
      "label": "Hide in preview",
      "disabled": _vm.lockHideInPreview,
      "id": _vm.item.name + '_hide_in_preview'
    },
    model: {
      value: (_vm.item.hideInPreview),
      callback: function($$v) {
        _vm.$set(_vm.item, "hideInPreview", $$v)
      },
      expression: "item.hideInPreview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shareWithParticipant && _vm.showShareWithParticipant) ? _c('editor-checkbox', {
    attrs: {
      "label": ("To be completed by " + _vm.participantSingularName),
      "id": _vm.item.name + '_tbc_by_participant'
    },
    model: {
      value: (_vm.item.by_participant),
      callback: function($$v) {
        _vm.$set(_vm.item, "by_participant", $$v)
      },
      expression: "item.by_participant"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasSharedFields && _vm.showIsShared) ? _c('editor-checkbox', {
    attrs: {
      "label": "Share field",
      "id": _vm.item.name + '_is_shared'
    },
    on: {
      "input": _vm.clearSharedReadonly
    },
    model: {
      value: (_vm.item.isShared),
      callback: function($$v) {
        _vm.$set(_vm.item, "isShared", $$v)
      },
      expression: "item.isShared"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasSharedFields && _vm.showIsShared) ? _c('editor-checkbox', {
    attrs: {
      "label": "Share as read-only",
      "disabled": !_vm.item.isShared,
      "id": _vm.item.name + '_share_readonly'
    },
    model: {
      value: (_vm.item.sharedReadOnly),
      callback: function($$v) {
        _vm.$set(_vm.item, "sharedReadOnly", $$v)
      },
      expression: "item.sharedReadOnly"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.descriptionRichEdit) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-editor', {
    attrs: {
      "id": _vm.item.name
    },
    model: {
      value: (_vm.item.description),
      callback: function($$v) {
        _vm.$set(_vm.item, "description", $$v)
      },
      expression: "item.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-label'
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.label),
      expression: "item.label"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-label',
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "label", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (!_vm.descriptionRichEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-description'
    }
  }, [_c('b', [_vm._v("Description")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.description),
      expression: "item.description"
    }],
    ref: "descriptionInput",
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-description',
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "description", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-grid'
    }
  }, [_vm._v("Grid size")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.grid),
      expression: "item.grid"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-grid'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.item, "grid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((12), function(index) {
    return _c('option', {
      key: index
    }, [_vm._v("\n          " + _vm._s(index) + "\n        ")])
  }), 0)]), _vm._v(" "), (_vm.item.type === 'switch') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": _vm.item.labelActive + '-labelActive'
    }
  }, [_vm._v("Label\n          active")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.labelActive),
      expression: "item.labelActive"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-labelActive',
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.labelActive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "labelActive", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": _vm.item.name + '-labelInactive'
    }
  }, [_vm._v("Label\n          inactive")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.labelInactive),
      expression: "item.labelInactive"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-labelInactive',
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.labelInactive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "labelInactive", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.type === 'destination-account') ? _c('div', [_c('p', [_vm._v("This field can't be optional. It's always required.")])]) : _vm._e(), _vm._v(" "), (['select_case_manager_secondary', 'select2'].includes(_vm.item.name)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select2")])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10987a66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorField.vue
// module id = 1559
// module chunks = 1